import React from 'react';
import { autoPlayBetStore } from '../../../store';
import { globalTranslationKeys } from '../../../enums';

export const AutoPlayStopPopUp = ({ t, text, value }) => {
  return (
    <div className='crash-info-holder'>
      <div className='crash-info-popup'>
        <div className='crash-info-popup-decors'>
          <div className='crash-info-popup-decor glow' />
          <div className='crash-info-popup-decor dots' />
        </div>
        <div className='crash-info-icon'>
          <span>
            <i className='crash-icon-error-outline' />
          </span>
          <i className='crash-info-i crash-icon-splash-1' />
          <i className='crash-info-i crash-icon-splash-1' />
          <i className='crash-info-i crash-icon-splash-1' />
        </div>
        <p className='crash-info-title' title={t(globalTranslationKeys.AutoplayHasStopped)}>
          {t(globalTranslationKeys.AutoplayHasStopped)}
        </p>
        <div className='crash-info-reason'>
          <div className='crash-info-reason-icon'>
            <span>
              <i className='crash-icon-success-outline' />
            </span>
            <i className='crash-reason-icon crash-icon-splash-1' />
            <i className='crash-reason-icon crash-icon-splash-1' />
          </div>
          {text && (
            <p className='crash-info-reason-txt' title={`${t(text)} ${value}`}>
              {`${t(text)} ${+value.toFixed(2)}`}
            </p>
          )}
        </div>
        <div
          className='crash-info-close'
          onClick={() => autoPlayBetStore.handleShowStopAutoPlayPopUp(false)}
        >
          <i className='ui-lib-close-x' />
        </div>
      </div>
    </div>
  );
};
